import { gql } from "@apollo/client"

const SIGNATURE_JOB_STEP_FIELDS = gql`
  fragment SignatureJobStepFields on SignatureJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
  }
`

export { SIGNATURE_JOB_STEP_FIELDS }
